import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

const svgProps = {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.4,
	strokeLinecap: "round",
	strokeLinejoin: "round",
} as const

/** Linear's project lead glyph: a person inside a dashed ring. */
export const LinearLeadIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg {...svgProps} ref={ref} {...props}>
		<circle cx="8" cy="8" r="6.6" strokeDasharray="1.6 1.9" />
		<circle cx="8" cy="6.5" r="1.7" />
		<path d="M5.1 11.4c.6-1.2 1.6-1.9 2.9-1.9s2.3.7 2.9 1.9" />
	</svg>
))

/** Linear's members glyph: two people side by side. */
export const LinearMembersIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg {...svgProps} ref={ref} {...props}>
			<circle cx="6" cy="5.2" r="2" />
			<path d="M2 12.6c.4-2 1.8-3.1 4-3.1s3.6 1.1 4 3.1" />
			<circle cx="11.2" cy="5.8" r="1.6" />
			<path d="M11.4 9.5c1.5.1 2.4 1 2.7 2.6" />
		</svg>
	),
)

/** Linear's start date glyph: a calendar with an arrow leaving it. */
export const LinearStartDateIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg {...svgProps} ref={ref} {...props}>
			<path d="M13.5 7.2V5A2.5 2.5 0 0 0 11 2.5H5A2.5 2.5 0 0 0 2.5 5v6A2.5 2.5 0 0 0 5 13.5h3" />
			<path d="M2.5 6h11" />
			<path d="M8.5 10.5h5.6M12.3 8.7l1.8 1.8-1.8 1.8" />
		</svg>
	),
)

/** Linear's target date glyph: a calendar with a solid header. */
export const LinearTargetDateIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			ref={ref}
			{...props}
		>
			<path d="M11 1a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4zm2.5 5h-11v5A2.5 2.5 0 0 0 5 13.5h6a2.5 2.5 0 0 0 2.5-2.5z" />
		</svg>
	),
)

/** Linear's labels glyph: an outlined tag. */
export const LinearLabelsIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			ref={ref}
			{...props}
		>
			<path d="M12 11.5V13H5.132v-1.5zm1.5-1.5V6a1.5 1.5 0 0 0-1.346-1.492L12 4.5H5.133a.5.5 0 0 0-.303.103l-.08.076-2.382 2.834a.5.5 0 0 0-.11.234l-.008.087v.331a.5.5 0 0 0 .118.321l2.382 2.835a.5.5 0 0 0 .383.179V13l-.22-.012a2 2 0 0 1-1.16-.54l-.15-.16L1.218 9.45a2 2 0 0 1-.46-1.11L.75 8.165v-.331a2 2 0 0 1 .363-1.147l.106-.14 2.383-2.834a2 2 0 0 1 1.312-.701L5.134 3H12a3 3 0 0 1 3 3v4a3 3 0 0 1-3.002 3v-1.5a1.5 1.5 0 0 0 1.494-1.347z" />
			<path d="M5.5 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0" />
		</svg>
	),
)
